"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FINGERPRINT = exports.ChecklistItemType = exports.ChecklistActionType = exports.ChecklistView = exports.AvroOptional = void 0;
exports.log = log;
const signals_logger_1 = require("@indeed/signals-logger");
const ChecklistView_1 = require("./ChecklistView");
Object.defineProperty(exports, "ChecklistView", { enumerable: true, get: function () { return ChecklistView_1.ChecklistView; } });
const ChecklistActionType_1 = require("./ChecklistActionType");
Object.defineProperty(exports, "ChecklistActionType", { enumerable: true, get: function () { return ChecklistActionType_1.ChecklistActionType; } });
const ChecklistItemType_1 = require("./ChecklistItemType");
Object.defineProperty(exports, "ChecklistItemType", { enumerable: true, get: function () { return ChecklistItemType_1.ChecklistItemType; } });
var signals_logger_2 = require("@indeed/signals-logger");
Object.defineProperty(exports, "AvroOptional", { enumerable: true, get: function () { return signals_logger_2.AvroOptional; } });
exports.FINGERPRINT = "1233b0c0b6d6bf6c";
function log(message) {
    (0, signals_logger_1.log)(exports.FINGERPRINT, message);
}
